import axios from 'axios';
import store from '@/store';
import helpers from '@/helpers';

export default {
	async getSchoolSummary (schoolId) {
		try {
			let academicYear = store.state.persistent.academicYear;
			let visit = store.state.persistent.visit;
			return await axios.get(`/coaching/reports/summary/school/${schoolId}`, {
				params: {
					startDate: helpers.dateTime.getISODate(academicYear.startDate),
					endDate: helpers.dateTime.getISODate(academicYear.endDate),
					visit: visit.value
				}
			});
		} catch (error) {
			throw error;
		}
	},

	async getSchoolProgress (schoolId) {
		try {
			let academicYear = store.state.persistent.academicYear;
			let visit = store.state.persistent.visit;
			return await axios.get(`/coaching/reports/progress/school/${schoolId}`, {
				params: {
					startDate: helpers.dateTime.getISODate(academicYear.startDate),
					endDate: helpers.dateTime.getISODate(academicYear.endDate),
					visit: visit.value
				}
			});
		} catch (error) {
			throw error;
		}
	},

	async getSchoolLanguagesSummary (schoolId) {
		try {
			let academicYear = store.state.persistent.academicYear;
			let visit = store.state.persistent.visit;
			return await axios.get(`/coaching/reports/summary/languages/school/${schoolId}`, {
				params: {
					startDate: helpers.dateTime.getISODate(academicYear.startDate),
					endDate: helpers.dateTime.getISODate(academicYear.endDate),
					visit: visit.value
				}
			});
		} catch (error) {
			throw error;
		}
	},

	async getSchoolLanguagesProgress (schoolId) {
		try {
			let academicYear = store.state.persistent.academicYear;
			let visit = store.state.persistent.visit;
			return await axios.get(`/coaching/reports/progress/languages/school/${schoolId}`, {
				params: {
					startDate: helpers.dateTime.getISODate(academicYear.startDate),
					endDate: helpers.dateTime.getISODate(academicYear.endDate),
					visit: visit.value
				}
			});
		} catch (error) {
			throw error;
		}
	},

	async getSchoolAcademicLevelsSummary (schoolId) {
		try {
			let academicYear = store.state.persistent.academicYear;
			let visit = store.state.persistent.visit;
			return await axios.get(`/coaching/reports/summary/academicLevels/school/${schoolId}`, {
				params: {
					startDate: helpers.dateTime.getISODate(academicYear.startDate),
					endDate: helpers.dateTime.getISODate(academicYear.endDate),
					visit: visit.value
				}
			});
		} catch (error) {
			throw error;
		}
	},

	async getSchoolAcademicLevelsProgress (schoolId) {
		try {
			let academicYear = store.state.persistent.academicYear;
			let visit = store.state.persistent.visit;
			return await axios.get(`/coaching/reports/progress/academicLevels/school/${schoolId}`, {
				params: {
					startDate: helpers.dateTime.getISODate(academicYear.startDate),
					endDate: helpers.dateTime.getISODate(academicYear.endDate),
					visit: visit.value
				}
			});
		} catch (error) {
			throw error;
		}
	},

	async getSchoolTeachersSummary (schoolId) {
		try {
			let academicYear = store.state.persistent.academicYear;
			let visit = store.state.persistent.visit;
			return await axios.get(`/coaching/reports/summary/teachers/school/${schoolId}`, {
				params: {
					startDate: helpers.dateTime.getISODate(academicYear.startDate),
					endDate: helpers.dateTime.getISODate(academicYear.endDate),
					visit: visit.value
				}
			});
		} catch (error) {
			throw error;
		}
	},

	async getSchoolTeachersProgress (schoolId) {
		try {
			let academicYear = store.state.persistent.academicYear;
			let visit = store.state.persistent.visit;
			return await axios.get(`/coaching/reports/progress/teachers/school/${schoolId}`, {
				params: {
					startDate: helpers.dateTime.getISODate(academicYear.startDate),
					endDate: helpers.dateTime.getISODate(academicYear.endDate),
					visit: visit.value
				}
			});
		} catch (error) {
			throw error;
		}
	},

	async getAdminSchoolHistory (schoolId) {
		try {
			return await axios.get(`/coaching/syntheses/school/${schoolId}`);
		} catch (error) {
			throw error;
		}
	},

	async getAdminSchoolHistoryByTypeId (schoolId, synthesisTypeId) {
		try {
			return await axios.get(`/coaching/syntheses/${schoolId}/${synthesisTypeId}`);
		} catch (error) {
			throw error;
		}
	},

	async getSynthesesReportByTypeId (synthesisTypeId, startDate = null, endDate = null) {
		try {
			let academicYear = store.state.persistent.academicYear;
			let visit = store.state.persistent.visit;
			return await axios.get(`/coaching/reports/synthesis`, {
				params: {
					synthesisTypeId,
					startDate: helpers.dateTime.getISODate(startDate || academicYear.startDate),
					endDate: helpers.dateTime.getISODate(endDate || academicYear.endDate),
					visit: visit.value
				}
			});
		} catch (error) {
			throw error;
		}
	},

	async getSynthesesDashboardByTypeId (synthesisTypeId, startDate = null, endDate = null) {
		try {
			let academicYear = store.state.persistent.academicYear;
			let visit = store.state.persistent.visit;
			let response = await axios.get(`/coaching/reports/dashboard`, {
				params: {
					coachingSynthesisTypeId: synthesisTypeId,
					startDate: helpers.dateTime.getISODate(startDate || academicYear.startDate),
					endDate: helpers.dateTime.getISODate(endDate || academicYear.endDate),
					visit: visit.value
				}
			});
			console.log(response);
			return response;
		} catch (error) {
			throw error;
		}
	},

	async getSummarySchools (startDate = null, endDate = null) {
		try {
			let academicYear = store.state.persistent.academicYear;
			let visit = store.state.persistent.visit;
			return await axios.get(`coaching/reports/schools-summary`, {
				params: {
					startDate: helpers.dateTime.getISODate(startDate || academicYear.startDate),
					endDate: helpers.dateTime.getISODate(endDate || academicYear.endDate),
					visit: visit.value ? parseInt(visit.value) : ''
				}
			});
		} catch (error) {
			throw error;
		}
	},

	async getHistoryByTypeId (synthesisTypeId) {
		try {
			//let response = await axios.get(`/coaching/reports/synthesis?synthesisTypeId=3&startDate=2019-08-01&endDate=2020-08-30`);
			return await axios.get(`/coaching/syntheses/type/${synthesisTypeId}`);
		} catch (error) {
			throw error;
		}
	},

	async getTrainingTalks () {
		try {
			return await axios.get(`/coaching/talks`);
		} catch (error) {
			throw error;
		}
	},

	async getEvaluation (evaluationId) {
		try {
			return await axios.get(`/coaching/${evaluationId}`);
		} catch (error) {
			throw error;
		}
	},

	async getIssue (issueId) {
		try {
			return await axios.get(`/issues/${issueId}`);
		} catch (error) {
			throw error;
		}
	},

	async getSynthesis (synthesisId) {
		try {
			return await axios.get(`/coaching/syntheses/${synthesisId}`);
		} catch (error) {
			throw error;
		}
	},

	async getAdminSchools () {
		try {
			return await axios.get(`/coaching/syntheses/summary`);
		} catch (error) {
			throw error;
		}
	},

	async getAdminSchoolIssues (schoolId) {
		try {
			return await axios.get(`/issues/school/${schoolId}`);
		} catch (error) {
			throw error;
		}
	},

	async getAdminSchoolEvaluations (schoolId) {
		try {
			return await axios.get(`/coaching/school/${schoolId}`);
		} catch (error) {
			throw error;
		}
	},

	async getAdminEvaluations () {
		try {
			return await axios.get(`/coaching`);
		} catch (error) {
			throw error;
		}
	},

	async getAdminIssues () {
		try {
			return await axios.get(`/issues`);
		} catch (error) {
			throw error;
		}
	},

	async getSchools () {
		try {
			return await axios.get(`/schools`);
		} catch (error) {
			throw error;
		}
	},

	async getAcademicYears () {
		try {
			return await axios.get(`/academic-years`);
		} catch (error) {
			throw error;
		}
	}

};



// WEBPACK FOOTER //
// ./src/api/coaching.js